import React, { createContext, useContext, useState } from 'react';
import { Options } from '../types/sorter';

type SorterOptionsContextType = {
  centerOptions: Options[];
  setCenterOptions: React.Dispatch<React.SetStateAction<Options[]>>;
  firmwareOptions: Options[];
  setFirmwareOptions: React.Dispatch<React.SetStateAction<Options[]>>;
  colorModelOptions: Options[];
  setColorModelOptions: React.Dispatch<React.SetStateAction<Options[]>>;
  reuseModelOptions: Options[];
  setReuseModelOptions: React.Dispatch<React.SetStateAction<Options[]>>;
  recyclingModelOptions: Options[];
  setRecyclingModelOptions: React.Dispatch<React.SetStateAction<Options[]>>;
};

const SorterOptionsContext = createContext<SorterOptionsContextType | null>(null);

export const SorterOptionsProvider = ({ children }: { children: React.ReactNode }) => {
  const [centerOptions, setCenterOptions] = useState<Options[]>([]);
  const [firmwareOptions, setFirmwareOptions] = useState<Options[]>([]);
  const [colorModelOptions, setColorModelOptions] = useState<Options[]>([]);
  const [reuseModelOptions, setReuseModelOptions] = useState<Options[]>([]);
  const [recyclingModelOptions, setRecyclingModelOptions] = useState<Options[]>([]);

  return (
    <SorterOptionsContext.Provider value={{
      centerOptions,
      setCenterOptions,
      firmwareOptions,
      setFirmwareOptions,
      colorModelOptions,
      setColorModelOptions,
      reuseModelOptions,
      setReuseModelOptions,
      recyclingModelOptions,
      setRecyclingModelOptions,
    }}>
      {children}
    </SorterOptionsContext.Provider>
  );
};

export const useSorterOptions = () => {
  const context = useContext(SorterOptionsContext);
  if (!context) throw new Error('useSorterOptions must be used inside SorterOptionsProvider');
  return context;
};
